import React from 'react';

import { useSurfacingExperimentContext } from '../../../../contexts';
import { useListingSignals } from '../../../hooks/useListingSignals';

import { Signal } from './Signal';

import styles from './ListingSignals.module.scss';

interface IListingSignalsProps {
    followCount: number;
}

export const ListingSignals: React.FC<IListingSignalsProps> = ({
    followCount,
}) => {
    const { ratingsData } = useSurfacingExperimentContext();
    const signals = useListingSignals(
        followCount,
        Number(ratingsData?.overall_experience.average ?? 0),
        Number(ratingsData?.overall_experience.total ?? 0),
    );

    if (!signals.length) return null;
    return (
        <ul className={styles.signalContainer}>
            {signals.map((signal) => {
                if (!signal.countEl || signal.countEl === '0') return null;
                return (
                    <Signal
                        key={signal.id}
                        countEl={signal.countEl}
                        title={signal.title}
                        testId={signal.testId}
                    />
                );
            })}
        </ul>
    );
};
